// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.

function validateSignupOnchange(value, fieldName, setEmailError, intl,
  setConfirmEmailError, registerData) {
  function validateEmail(email) {
    // eslint-disable-next-line
    const re =/^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])\s*$/;
    return re.test(email);
  }
  const isValidEmail = validateEmail(value);

  if ((isValidEmail === false && value !== "" && fieldName === "email")) {
    setEmailError(intl.getI18nMessage("label.user.profile.email.format.error"))
  } else if ((isValidEmail === true && value !== "" && fieldName === "email")) {
    setEmailError("")
  }
  if (registerData.email !== registerData.confirmEmail) {
    setConfirmEmailError(intl.getI18nMessage("label.signup.email.match.error"))
  } else if (registerData.email === registerData.confirmEmail) {
    setConfirmEmailError("")
  }
}

function validateSignupOnSubmit(registerData, setSignupEmailError, setSignupConfirmEmailError,
  registerUser, intl, sliderValue, setSliderError) {
  if (registerData.email === "") {
    setSignupEmailError(intl.getI18nMessage("label.user.profile.email.mandatory"))
  } else if (registerData.confirmEmail === "") {
    setSignupConfirmEmailError(intl.getI18nMessage("label.signup.confirm.email.mandatory.error"))
  } else if (sliderValue !== 100) {
    setSliderError(intl.getI18nMessage("error.field.mandatory"))
  } else if ((registerData.email !== "" && registerData.confirmEmail !== "") &&
    (registerData.email === registerData.confirmEmail) && sliderValue === 100) {
    setSliderError("")
    const data = {
      email: registerData?.email,
      organizationName: registerData?.organizationName,
      organizationDescription: registerData?.organizationDesc,
    }

    registerUser(data)
  }
}

const checkAllFieldsEmpty = (obj) => {
  for (const key in obj) {
    if (obj[key] !== '') {
      return false;
    }
  }
  return true;
};


export {
  validateSignupOnchange,
  validateSignupOnSubmit,
  checkAllFieldsEmpty,
}
